import {Component, effect, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {FrontendNotificationService} from '../../../../frontend/service/frontend-notification.service';
import {InfoTextComponent} from '../../../../shared/common/info-text/info-text.component';
import {Button} from 'primeng/button';
import {TranslatePipe} from '@ngx-translate/core';
import {environment} from '../../../../../../environments/environment';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../service/player-profile.service';

@Component({
  selector: 'app-player-profile-settings-push-notification',
  imports: [
    InfoTextComponent,
    Button,
    TranslatePipe
  ],
  templateUrl: './player-profile-settings-push-notification.component.html',
  styleUrl: './player-profile-settings-push-notification.component.scss'
})
export class PlayerProfileSettingsPushNotificationComponent implements OnInit, OnDestroy
{
  private frontendNotificationService = inject(FrontendNotificationService);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);

  @Input() dashboardView: boolean;

  runsInApp = this.frontendNotificationService.runsInApp;
  fcmToken = this.frontendNotificationService.fcmToken;

  isTestServer: boolean;
  isLocal: boolean;
  tokenRequested: boolean;

  constructor()
  {
    effect(() => {
      this.tokenReceived(this.fcmToken());
    });
  }

  ngOnInit(): void
  {
    this.isTestServer = !environment.production;
    this.isLocal = environment.local;
  }

  ngOnDestroy(): void
  {
    if (this.tokenRequested)
      this.updateToken();
  }

  private tokenReceived(token: string): void
  {
    console.log('tokenReceived: ' + token);
    this.updateToken();
  }

  private updateToken(): void
  {
    this.playerProfileService.loadProfileData().subscribe({
      next: () => {
        console.log('FCM Token aktualisiert');
        this.tokenRequested = false;
      }
    });
  }

  public requestToken(): void
  {
    this.frontendNotificationService.requestTokenInApp();
    this.tokenRequested = true;
  }

  public showTokenDetails(): void
  {
    this.restErrorHelper.showInfoMessageService(this.fcmToken(), 5000);
  }

  public testPushNotification(): void
  {
    this.playerProfileService.testPushNotification().subscribe({
      next: () => console.log('Push-Benachrichtigung versendet'),
      error: error => this.restErrorHelper.handleErrorService(error)
    });
  }
}
